import React from "react"
import { Col, Image, Row, Table } from "react-bootstrap"

export default function GuideSection() {
  return (
    <section style={{ marginTop: "4em" }}>
      <p className="font-weight-bold h5">Panduan ukuran kaos</p>
      <Row className="flex-md-row-reverse justify-content-between align-items-center">
        <Col md={6}>
          <Image src={`/guide.png`} fluid />
        </Col>
        <Col md={6}>
          <Table className="mt-5" striped bordered hover>
            <thead>
              <tr>
                <th>Ukuran</th>
                <th>Lebar x Panjang</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>S</td>
                <td>47 x 67</td>
              </tr>
              <tr>
                <td>M</td>
                <td>49 x 69</td>
              </tr>
              <tr>
                <td>L</td>
                <td>51 x 71</td>
              </tr>
              <tr>
                <td>XL</td>
                <td>53 x 73</td>
              </tr>
              <tr>
                <td>XXL</td>
                <td>55 x 73</td>
              </tr>
            </tbody>
          </Table>
          <p>*harap perhatikan ukuran badan anda ya</p>
        </Col>
      </Row>
    </section>
  )
}
